import React, { Component } from "react";
import axios from "axios";
import Navbar from "../navbar/topnav";
import { siteName, siteAccessCode, urlSites, urlPageSites, urlSiteList, 
        siteAddress, siteCity, siteState, siteZip, sitePropertyId, siteGeoLocation, siteCSZCombo } 
    from "../database/apiv2SiteAccessor";
import {promiseData, } from '../database/apiMethods'
import SiteGuideRender, {SiteFailRender} from "./SiteGuideRender";
import { MapMergeTest } from "./GuestList";
import { renderLoader } from "../Loading/loading";
import { mostRecentRead, favRead } from "../Overview/MostRecent";

import "./SiteList.css";
import LeafletMap from "../maps/leaflet_intro";

let loadState = {
  status: undefined
}
let markerContent = 0;
export function LoadSites (props) {
  loadState.status = undefined
  const p1 = promiseData(urlSites(), props.authToken);
  const p2 = promiseData(urlSiteList(), props.authToken);
  return Promise.all([p1, p2])
    .then ((siteAPI) => {
      loadState.status = siteAPI[0]?.status ?? 200
      if (siteAPI[0]?.data?.more === 'True' && siteAPI[0]?.data?.lastAcValue) {
        promiseData(urlPageSites(siteAPI[0]?.data?.lastAcValue), props.authToken)
          .then (page => {
            siteAPI[0].data.data.push(...page?.data?.data)
            mapSites(siteAPI[0]?.data?.data, siteAPI[1]?.data?.data?.sites, props)
          })
      }
      else { 
        mapSites(siteAPI[0]?.data?.data, siteAPI[1]?.data?.data?.sites, props)
      }
    })
    .catch ((error) => {
      loadState.status = error?.response?.status ?? 500
      props.siteMap(new Map())
  })
}
async function addMBLocations (sites, props) {
  let proms = []
  for (const [ac, site] of sites) {
    if (!siteGeoLocation(site)) {
      proms.push(getGeoCode(site).then (loc => {
        if (loc) {
          site.geoCode = loc
          site.pinStyle = 1
          sites.set (ac, site)
        }
      }))
    }
  }
  Promise.allSettled(proms).then(()=> {
    markerContent +=1
    props.batteryFormat(props.batteryFormat(undefined))
  })
}
function mapSites (sites1, sites2, props) {
  const smap = MapMergeTest(sites1, sites2)
  addMBLocations (smap, props)
  props.siteMap(smap)
}
const mbauth = '&access_token='+process.env.REACT_APP_MAPBOX
async function getGeoCode(site) {
  const params = [
    siteAddress(site) ? "address_line1="+encodeURIComponent(siteAddress(site)): "",
    siteCity(site) ? "place="+encodeURIComponent(siteCity(site)) :"",
    siteState(site) ? "region="+encodeURIComponent(siteState(site)) : "",
    siteZip(site) ? "postcode="+encodeURIComponent(siteZip(site)) : "",
  ]
  const search = params.filter(i=>i.length > 0).join('&')
  if (search.length > 0) {
    const url = 'https://api.mapbox.com/search/geocode/v6/forward?country=us,ca&'+search+mbauth
    const geo = axios.get(url).then((resp) => {
      return resp?.data?.features[0]?.geometry?.coordinates.reverse()
    })
    return geo
  }
  return undefined
}

function tidySL(data) {
  if (data) {
    data.sort((a, b) => siteName(a).localeCompare(siteName(b)));
    data.forEach((site, index) =>
      siteAccessCode(site) ? () => {} : site.access_code = "MissingAC" + index)
  }
  return data;
}
const filterMap = (map, callback) => new Map (
  [...map].filter(([key, value]) => callback(value))
);
export function siteFilter (sites, match) { /// sites is a map
  if (match && match.length > 0) {
    const lmatch = match.toLowerCase()
    const result = filterMap(sites, (site) => {
      return (
        siteName(site).toLowerCase().indexOf(lmatch) >-1 ||
        siteAccessCode(site).indexOf(lmatch) > -1 ||
        siteCity(site).toLowerCase().indexOf(lmatch) > -1 ||
        siteAddress(site).toLowerCase().indexOf(lmatch) > -1 ||
        sitePropertyId(site).toLowerCase().indexOf(lmatch) > -1 ||
        site?.site_details?.tsm_conn_type?.toLowerCase().indexOf(lmatch) > -1
      )})
    return result
  }
  return sites
}
export default class SiteList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadState: undefined,
      sites: [],
      filterSites: new Map(),
      filterText: '',
      isLoading: true,
      loader: renderLoader(),
      noSites: false,
      mruFilterOn: false,
      favFilterOn: false,
    };
    this.timerId = undefined
    this.markerContent = 0
  }

  async componentDidMount() {
    // Tour code
    this.props.updateSiteLocation("chgsite");
    this.props.launchTourStatus(true);
    // End tour code
    if (this.props.loginExpired()) {
      this.props.history.push('login')
      return
    }
    LoadSites(this.props)
    const sites = this.props.siteMap()
    if (sites.size && loadState.status) {
      this.setState({sites: sites, filterSites: sites, noSites: false, isLoading: false,})
    }
    else if (loadState.status) {
      this.setState({isLoading: false, noSites: true})
      console.log ("something's wrong", sites, this.props)
    }
    this.loadTimeout (35)
  }
  componentDidUpdate() {
    if (loadState.status === this.state.loadState) {
      if (this.state.isLoading) {
        this.setState({isLoading: false})
        clearInterval (this.timerId)
        markerContent +=1
      }
      return
    }
    if (loadState.status === 404 || loadState.status === 400) {
      this.setState({isLoading: false, noSites: true, loadState: loadState.status})
      clearInterval (this.timerId)
      return
    }
    if (loadState.status < 300) {
      const sites = this.props.siteMap()
      this.setState ({sites: sites, filterSites: sites, isLoading: false, noSites: false, loadState: loadState.status})
      clearInterval (this.timerId)
    }
    else {
      this.setState({loadState: loadState.status, isLoading: false})
      clearInterval (this.timerId)
      markerContent +=1
    }
  }
  loadTimeout (seconds) {
    let timeLeft = seconds;
    this.timerId = setInterval(() => {
      timeLeft--;
      if (timeLeft <= 0) {
        clearInterval(this.timerId); // Stop the timer
        this.setState({isLoading: false})
      } 
    }, 1000); // Runs every 1 second
  }
  sitelistFilter = (search) => {
    const sites = this.props.siteMap()
    this.setState({filterSites: siteFilter(sites, search),
      filterText: search,
    });
  };
  mruFilter = () => {
    const filter = !this.state.mruFilterOn
    const sites = this.props.siteMap()
    const mru = mostRecentRead(this.props.userLogin)
    if (filter && mru.length > 0) {
      const recents = filterMap(sites, (site) => mru.find(m =>m.ac === siteAccessCode(site)))
      this.setState({filterSites: recents, mruFilterOn: filter, favFilterOn: false})
    }
    else
      this.setState({filterSites: sites, mruFilterOn: filter})
  }
  favFilter = () => {
    const sites = this.props.siteMap()
    const filter = !this.state.favFilterOn
    const fav = favRead(this.props.userLogin)
    if (filter && fav.length > 0) {
      const recents = filterMap(sites, (site) => fav.find(m => m.ac === siteAccessCode(site)))
      this.setState({filterSites: recents, favFilterOn: filter, mruFilterOn: false})
    }
    else
      this.setState({filterSites: sites, favFilterOn: filter})
  }
  siteListRender() {
    const showGuide = this.state.noSites
    if (showGuide)
      return <SiteGuideRender {...this.props} />
    if (loadState.status !== undefined && loadState.status >= 300)
      return <SiteFailRender {...this.props} />
    return <LeafletMap {...this.props} sites={this.state.filterSites}
        siteFilter={this.sitelistFilter} content={markerContent}
        filterText={this.state.filterText} 
        mruFilter={this.mruFilter} mruFilterOn={this.state.mruFilterOn}
        favFilter={this.favFilter} favFilterOn={this.state.favFilterOn}/>
  }

  render() {
    return (
      <div>
        <Navbar {...this.props} menucontext="sitelist"
          parentUpdate={this.props.parentUpdate}
        />
        {this.state.isLoading ? this.state.loader: this.siteListRender() }
      </div>
    );
  }
}
